import * as api from './'

export type RequestParams = Record<string, unknown>

class BaseRequest {
  static section = '/'

  static buildUrl(url: string): string {
    return this.section + url
  }

  static get<T = unknown>(url: string, params?: RequestParams): Promise<T> {
    return api
      .get(this.buildUrl(url), params)
      .then(response => response?.data as T)
      .catch(error => {
        // Surface CMS failures instead of silently returning undefined.
        // eslint-disable-next-line no-console -- intentional CMS failure visibility
        console.error(`[CMS] GET ${this.buildUrl(url)} failed`, error)
        return Promise.reject(error?.data ?? error)
      })
  }

  static post<T = unknown>(url: string, data?: unknown): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .post(this.buildUrl(url), data)
        .then(response => resolve(response?.data as T))
        .catch(error => reject(error?.data ?? error)),
    )
  }

  static patch<T = unknown>(url: string, data?: unknown): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .patch(this.buildUrl(url), data)
        .then(response => resolve(response?.data as T))
        .catch(error => reject(error?.data ?? error)),
    )
  }

  static delete<T = unknown>(url: string, data?: unknown): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .remove(this.buildUrl(url), data)
        .then(response => resolve(response?.data as T))
        .catch(error => reject(error?.data ?? error)),
    )
  }
}

export default BaseRequest
